import getConfiguration from "./config.js";

const allowedBrowsers = {};
let deprecatedBrowser = false;

function isBrowserAuthorized (version, browser) {
    const sortVersionNumber = function(a, b){ return a - b; };
    const getMajorVersion = function(v){ return Number(v.toString().split('.')[0]); };

    const acceptedVersions = allowedBrowsers[browser].accepted.sort(sortVersionNumber);
    const deprecatedVersions = allowedBrowsers[browser].deprecated;
    const allowHigherVersions = allowedBrowsers[browser].allowHigherVersions;

    if (acceptedVersions.includes(getMajorVersion(version))){
        return true;
    } else if(deprecatedVersions && deprecatedVersions.includes(getMajorVersion(version))) {
        deprecatedBrowser = true;
        return true;
    } else if (getMajorVersion(version) > acceptedVersions[acceptedVersions.length - 1]) {
        return allowHigherVersions;
    }
    return false;
}

export default function checkBrowserVersion (includeDetails = false) {
    return new Promise((resolve, reject) => {
        const ua = navigator.userAgent.toLowerCase();
        const check = function(regex){
            return regex.test(ua);
        };
        const version = function (is, regex) {
            let m;
            return (is && (m = regex.exec(ua))) ? parseFloat(m[1]) : 0;
        };
        const docMode = document.documentMode;
        const isQuirksDocMode = docMode === undefined || docMode === 5;
        const isOpera = check(/opera/);
        const isChrome = check(/\bchrome\b/);
        const isWebKit = check(/webkit/);
        const isSafari = !isChrome && check(/safari/);
        const isIE = !isOpera && (check(/msie/) || check(/trident/));
        const isIE7 = isIE && ((check(/msie 7/) && isQuirksDocMode) || docMode === 7);
        const isIE8 = isIE && ((check(/msie 8/) && isQuirksDocMode) || docMode === 8);
        const isIE9 = isIE && ((check(/msie 9/) && isQuirksDocMode) || docMode === 9);
        const isIE10 = isIE && ((check(/msie 10/) && isQuirksDocMode) || docMode === 10);
        const isIE11 = isIE && ((check(/trident\/7\.0/) && isQuirksDocMode) || docMode === 11);
        const isIE6 = isIE && check(/msie 6/);
        const isEdge = check(/edge/);
        const isFirefox = !isWebKit && !isIE && check(/gecko/); // IE11 adds "like gecko" into the user agent string
        const isWindows = check(/windows|win32/);
        const isMac = check(/macintosh|mac os x/);
        const chromeVersion = version(true, /\bchrome\/(\d+\.\d+)/);
        const edgeVersion = version(true, /\bedge\/(\d+\.\d+)/);
        const firefoxVersion = version(true, /\bfirefox\/(\d+\.\d+)/);
        const safariVersion = version(isSafari, /version\/(\d+\.\d+)/);
        const ieVersion = version(isIE, (function () {
            if (isIE6 || isIE7 || isIE8 || isIE9 || isIE10) {
                return /msie (\d+\.\d+)/;
            } else { // IE 11
                return /rv:(\d+)/;
            }
        }()));
        getConfiguration()
            .then(config => {
                Object.assign(allowedBrowsers, config.allowedBrowsers);
                // return authorized browser
                const o = {
                    authorized: false,
                    legacy: isIE
                };
                if (
                    isIE && isBrowserAuthorized(ieVersion, 'ie') ||
                    isChrome && isBrowserAuthorized(chromeVersion, 'chrome') ||
                    isFirefox && isBrowserAuthorized(firefoxVersion, 'firefox') ||
                    isSafari && isBrowserAuthorized(safariVersion, 'safari') ||
                    isEdge && isBrowserAuthorized(edgeVersion, 'edge')
                ){
                    o.authorized = true;
                    o.deprecated = deprecatedBrowser;
                    // optionally add information
                    if (includeDetails === true) {
                        o.vendor = isIE ? 'Internet Explorer' : isChrome ? 'Chrome' : isFirefox ? 'Firefox' : isSafari ? 'Safari' : isEdge ? 'Edge' : 'unsupported browser';
                        o.version = isIE ? ieVersion : isChrome ? chromeVersion : isFirefox ? firefoxVersion : isSafari ? safariVersion : isEdge ? edgeVersion : 'unknown';
                        o.platform = isWindows ? 'windows' : isMac ? 'macintosh' : 'unknown';
                    }
                }
                resolve(o);
            })
            .catch(error => {
                reject(error);
            });
    });

}